import React, { Component } from 'react';

import { connect } from 'react-redux';

import { RootState } from '../../../store/rootReducer';

interface IMapStateToProps {
  questionFontColor: string;
}

class VideoQuestionStyleBase extends Component<IMapStateToProps> {
  render() {
    const { questionFontColor } = this.props;

    return (
      <style type="text/css" scoped>
        {`
          .video-question-tips {
            color: ${questionFontColor};
            .sx-icon {
              color: ${questionFontColor};
            }
          }
          .video-question-confirmation {
            p {
              color: ${questionFontColor};
            }
          }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  const {
    question: { color },
  } = state.customization ?? {};
  return {
    questionFontColor: color,
  };
};

export const VideoQuestionStyle = connect(mapStateToProps)(VideoQuestionStyleBase);
